<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE PARÂMETROS DE VISITAS'"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div
          class="input-group col-md-4"
          style="background: none"
        >
          <div style="width: 100%">
            <label for="ToogleSwitchPassword">
              Habilitar informe de hodometro?
            </label>
            <ToogleSwitch
              id="ToogleSwitchPassword"
              v-model="data.hasHodometro"
            />
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ParametroConfigVisitasRepository from '@/shared/http/repositories/configurations/parametroConfigVisitas.js'

import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

const data = {
  id: null,
  hasHodometro: false
}

export default {
  name: 'OpenCardVisitasParams',
  mixins: [ActionsForm],
  data () {
    return {
      data: data
    }
  },
  components: {
    ToogleSwitch
  },
  methods: {
    async onLoad () {
      try {
        loading.push()
        const resp = await ParametroConfigVisitasRepository.Get()

        if (!resp || !resp.data) {
          return
        }

        this.setResponseInData(resp.data)
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    onClear () {
      this.data.hasHodometro = false
    },
    async onCreate () {
      try {
        loading.push()
        const response = await ParametroConfigVisitasRepository.Create(
          this.data
        )

        if (response && response.status === 201) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    async onUpdate () {
      try {
        loading.push()
        const response = await ParametroConfigVisitasRepository.Update(
          this.data
        )

        if (response && response.status === 200) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    setResponseInData (respData) {
      this.data.id = parseInt(respData.id)
      this.data.hasHodometro = respData.hasHodometro
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/visitas/hodometro/UseHodometroParams.vue